<section tuiTableContainer>
	<div #scroller tuiTableWrapper>
		<table
			tuiTable
			[columns]="columnKeys"
			[direction]="(direction$ | async) || 1"
			[tuiSortBy]="sorter$ | async"
			(directionChange)="direction$.next($event)"
			(tuiSortChange)="onSortChange($any($event))"
			appearance="tight"
		>
			<thead>
				<tr tuiThGroup>
					<th
						tuiTh
						size="index"
						*tuiHead="'index'"
						[tuiSortable]="false"
					></th>

					<th
						tuiTh
						size="l"
						*tuiHead="entity()"
						[tuiSortable]="false"
					>
						{{
							'customer-product.top-count.' + entity() | transloco
						}}
					</th>

					<th
						tuiTh
						size="s"
						*tuiHead="'revenueInCents'"
						[tuiSortable]="false"
					>
						{{ 'customer-product.top-count.revenue' | transloco }}
					</th>

					<th
						tuiTh
						size="xs"
						*tuiHead="'count80'"
						[tuiSortable]="false"
					>
						{{ translation() + '.count-of-80' | transloco }}
					</th>

					<th
						tuiTh
						size="xs"
						*tuiHead="'count20'"
						[tuiSortable]="false"
					>
						{{ translation() + '.count-of-20' | transloco }}
					</th>

					<th
						tuiTh
						size="xs"
						*tuiHead="'percent80'"
						[tuiSortable]="false"
					>
						{{ translation() + '.%-of-80' | transloco }}
					</th>

					<th
						tuiTh
						size="xs"
						*tuiHead="'transactionCount'"
						[tuiSortable]="false"
					>
						{{
							'customer-product.top-count.transactions'
								| transloco
						}}
					</th>

					<th
						tuiTh
						size="xs"
						*tuiHead="'transactionAvgInCents'"
						[tuiSortable]="false"
					>
						{{
							'customer-product.top-count.average-transaction'
								| transloco
						}}
					</th>

					<th
						tuiTh
						size="xs"
						*tuiHead="'marginPercent80'"
						[tuiSortable]="false"
					>
						@if ('direct' | isCostType) {
							{{ translation() + '.cm%-80' | transloco }}
						} @else {
							{{ translation() + '.mm%-80' | transloco }}
						}
					</th>

					<th
						tuiTh
						size="xs"
						*tuiHead="'marginPercent20'"
						[tuiSortable]="false"
					>
						@if ('direct' | isCostType) {
							{{ translation() + '.cm%-20' | transloco }}
						} @else {
							{{ translation() + '.mm%-20' | transloco }}
						}
					</th>

					<th
						tuiTh
						size="xs"
						*tuiHead="'marginPercent'"
						[tuiSortable]="false"
					>
						@if ('direct' | isCostType) {
							{{ translation() + '.cm%-total' | transloco }}
						} @else {
							{{ translation() + '.mm%-total' | transloco }}
						}
					</th>
				</tr>
			</thead>
			@if (paginatedObject; as data) {
				@let sortedData = data.items | tuiTableSort;
				<tbody tuiTbody [data]="sortedData">
					@if (loading$ | async) {
						<!-- 11 for the additional footer at the bottom of the table -->
						@for (item of [].constructor(11); track $index) {
							<tr [class.tr-footer]="$last">
								<td><p></p></td>
								@for (
									item of [].constructor(10);
									track $index
								) {
									<td>
										<p class="m-0" [tuiSkeleton]="2"></p>
									</td>
								}
							</tr>
						}
					} @else if (data.items.length) {
						@for (item of data.items; track item.id) {
							<tr tuiTr>
								<td
									*tuiCell="'index'"
									tuiTd
									[innerText]="$index + 1"
								></td>

								<td
									*tuiCell="entity()"
									tuiTd
									[innerText]="item.data[entity()]"
								></td>

								<td
									*tuiCell="'revenueInCents'"
									tuiTd
									[innerText]="
										item.data.revenueInCents
											| centsToDollars
									"
								></td>

								<td
									*tuiCell="'count80'"
									tuiTd
									[innerText]="item.data.count80"
								></td>

								<td
									*tuiCell="'count20'"
									tuiTd
									[innerText]="item.data.count20"
								></td>

								<td *tuiCell="'percent80'" tuiTd>
									<mar-percent-of-eighty-cell
										[percentiles]="
											percentiles()?.percent80 ?? null
										"
										[value]="item.data.percent80"
									/>
								</td>

								<td
									*tuiCell="'transactionCount'"
									tuiTd
									[innerText]="item.data.transactionCount"
								></td>

								<td *tuiCell="'transactionAvgInCents'" tuiTd>
									<mar-average-transaction-cell
										[percentiles]="
											percentiles()
												?.transactionAvgInCents ?? null
										"
										[value]="
											item.data.transactionAvgInCents
										"
									/>
								</td>

								<td *tuiCell="'marginPercent80'" tuiTd>
									@if (item.data.marginPercent80) {
										<mar-margin-percent-eighty-cell
											[value]="item.data.marginPercent80"
											[marginPercent20]="
												item.data.marginPercent20
											"
										/>
									}
								</td>

								<td *tuiCell="'marginPercent20'" tuiTd>
									@if (item.data.marginPercent20) {
										<mar-margin-percent-twenty-cell
											[value]="item.data.marginPercent20"
											[marginPercent80]="
												item.data.marginPercent80
											"
										/>
									}
								</td>

								<td *tuiCell="'marginPercent'" tuiTd>
									@if (item.data.marginPercent) {
										<mar-margin-percent-total-cell
											[percentiles]="
												percentiles()?.marginPercent ??
												null
											"
											[value]="item.data.marginPercent"
										/>
									}
								</td>
							</tr>
						}

						@if (rollupAverage(); as average) {
							<tr tuiTr class="tr-footer">
								<td *tuiCell="'index'" tuiTd><p></p></td>

								<td *tuiCell="entity()" tuiTd>
									<p class="font-bold">
										{{
											'customer-product.top-count.average-80-' +
												entity() | transloco
										}}
									</p>
								</td>

								<td
									tuiTd
									*tuiCell="'revenueInCents'"
									[innerText]="
										average.revenueInCents | centsToDollars
									"
								></td>

								<td
									tuiTd
									*tuiCell="'count80'"
									[innerText]="average.count80"
								></td>

								<td
									tuiTd
									*tuiCell="'count20'"
									[innerText]="average.count20"
								></td>

								<td
									tuiTd
									*tuiCell="'percent80'"
									[innerText]="
										average.percent80 | percentToValue
									"
								></td>

								<td
									tuiTd
									*tuiCell="'transactionCount'"
									[innerText]="average.transactionCount"
								></td>

								<td
									tuiTd
									*tuiCell="'transactionAvgInCents'"
									[innerText]="
										average.transactionAvgInCents
											| centsToDollars
									"
								></td>

								<td
									tuiTd
									*tuiCell="'marginPercent80'"
									[innerText]="
										average.marginPercent80 | percentToValue
									"
								></td>

								<td
									tuiTd
									*tuiCell="'marginPercent20'"
									[innerText]="
										average.marginPercent20 | percentToValue
									"
								></td>

								<td
									tuiTd
									*tuiCell="'marginPercent'"
									[innerText]="
										average.marginPercent | percentToValue
									"
								></td>
							</tr>
						}
					} @else {
						<tr>
							<td [colSpan]="11">
								<div tuiTablePlaceholder>
									<h2 class="max-w-md">
										{{
											'customer-product.top-count.placeholder.not-enough-data'
												| transloco
										}}
									</h2>
								</div>
							</td>
						</tr>
					}
				</tbody>
			}
		</table>
	</div>
</section>

<div class="flex justify-between items-center px-3 py-1">
	<small class="italic block text-inherit">
		{{ 'generic.disclaimer.rounded' | transloco }}
	</small>

	<button
		tuiLink
		[attr.appearance]="appearance()"
		iconStart="@tui.info"
		class="font-semibold"
		(click)="onInfo()"
	>
		{{ 'customer-product.top-count.action.info' | transloco }}
	</button>
</div>
